<template>
  <modal-vue-d
    :name="name"
    width="1140"
    class-modal="_city"
    @before-open="modalBeforeOpenHandler"
  >
    <div class="choose-city-order" :class="{ '_world-delivery': isWorldDelivery }">
      <div class="choose-city-order__heading">
        <div class="choose-city-order__title">
          Выберите город
        </div>
        <template v-if="!isWorldDelivery">
          <div class="choose-city-order__current">
            <icon
              name="Location_16"
              width="16"
              height="16"
              class="choose-city-order__inline-icon"
            />
            <span>Текущий город:</span>
            <nobr class="choose-city-order__current-name">
              <b>{{ city.name }}</b>
            </nobr>
          </div>
          <div class="choose-city-order__detect-block">
            <a
              class="choose-city-order__detect"
              :href="jsv"
              @click.prevent="detectClickHandler"
            >
              <icon
                name="location"
                width="16"
                height="16"
                class="choose-city-order__inline-icon"
              />
              {{ detectCaption }}
            </a>
          </div>
        </template>
        <div v-else class="choose-city-order__line-info">
          <div class="choose-city-order__city-info">
            <div class="choose-city-order__current">
              <icon
                name="Location_16"
                width="16"
                height="16"
                class="choose-city-order__inline-icon"
              />
              <span>Текущий город:</span>
              <nobr class="choose-city-order__current-name">
                <b>{{ city.name }}</b>
              </nobr>
            </div>
            <div class="choose-city-order__detect-block">
              <a
                class="choose-city-order__detect"
                :href="jsv"
                @click.prevent="detectClickHandler"
              >
                <icon
                  name="location"
                  width="16"
                  height="16"
                  class="choose-city-order__inline-icon"
                />
                {{ detectCaption }}
              </a>
            </div>
          </div>
          <div class="choose-city-order__world-delivery">
            <world-delivery class="_d" href="/foreign-orders/" target="_blank">
              Международная доставка
            </world-delivery>
          </div>
        </div>
      </div>
      <div class="choose-city-order__search-wrapper">
        <search-field-city
          v-model="foundCity"
          class="choose-city-order__search"
          :outer-input-props="searchInputAttributes"
          @change="searchChangeHandler"
        />
      </div>
      <div class="choose-city-order__list">
        <city-list
          :region-opened="regionOpened"
          :region-name="regionName"
          :populars-marked="popularsMarked"
          :list="list"
          @popular-click="popularClickHandler"
          @region-click="regionClickHandler"
          @back-click="backClickHandler"
        />
      </div>
    </div>
    <message-preloader v-if="loading" />
  </modal-vue-d>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import locationPopular from '@/js/services/api/locationPopular';
import getCitiesOfRegion from '@/js/services/api/getCitiesOfRegion';
import geoDetectCity from '@/js/helpers/location/geoDetectCity';

import sendErrorDataLayer from '@/js/helpers/sendErrorDataLayer';

import ModalVueD from '@/js/vue/ModalVueD';
import Icon from '@/js/vue/Icon';
import WorldDelivery from '@/js/vue/WorldDelivery';
import CityList from '@/js/vue/CityList';
import MessagePreloader from '@/js/vue/MessagePreloader';
import SearchFieldCity from '@/js/vue/SearchFieldD/City';
import pushToDataLayer from '@/js/helpers/pushToDataLayer';

const importantLocations = ['0c5b2444-70a0-4932-980c-b4dc0d3f02b5', 'c2deb16a-0330-4f05-821f-1d09c93331e6'];
const searchInputAttributes = {
  searchSmall: true,
  class: ['_search'],
  placeholder: 'Введите название населенного пункта',
};

export default {
  components: {
    Icon,
    CityList,
    MessagePreloader,
    SearchFieldCity,
    WorldDelivery,
    ModalVueD,
  },
  props: {
    city: {
      type: Object,
      default: () => ({}),
    },
    isWorldDelivery: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'city-modal',
    },
  },
  data() {
    return {
      jsv: 'javascript:void(0);',
      populars: [],
      regions: [],
      regionCities: [],
      regionName: '',
      loadingStack: [],
      detectError: false,
      foundCity: {},
      searchInputAttributes,
    };
  },
  computed: {
    popularsMarked() {
      return this.populars.map(city => ({
        important: importantLocations.indexOf(city.location) !== -1, ...city,
      }));
    },
    list() {
      return this.regionOpened ? this.regionCities : this.regions;
    },
    regionOpened() {
      return !!this.regionCities.length;
    },
    loading() {
      return !!this.loadingStack.length;
    },
    detectCaption() {
      return this.detectError ? 'Не удалось определить автоматически' : 'Определить автоматически';
    },
    listsLoaded() {
      return this.populars.length && this.regions.length;
    },
  },
  methods: {
    modalBeforeOpenHandler() {
      this.clearRegionCities();

      if (!this.listsLoaded) {
        this.updateLists();
      }
    },
    popularClickHandler(city) {
      pushToDataLayer({ event: 'step2_location_change' });
      this.setCity(city);
    },
    regionClickHandler(city) {
      if (this.regionOpened) {
        pushToDataLayer({ event: 'step2_location_change' });
        this.setCity(city);
      } else {
        this.setRegionName(city.name);
        this.updateRegionCities(city);
      }
    },
    backClickHandler() {
      this.clearRegionCities();
    },
    detectClickHandler() {
      this.detectCity();
    },
    searchChangeHandler(city) {
      if (!isEmpty(city)) {
        this.setCity(city);
      }
    },
    clearRegionCities() {
      this.regionCities = [];
    },
    setRegionName(name) {
      this.regionName = name;
    },
    setLoading(loading) {
      if (loading) {
        this.loadingStack.push(true);
      } else {
        this.loadingStack.pop();
      }
    },
    setCity(city, coordinates) {
      const cityName = city.name.split(',');
      const newCityObject = { ...city };
      newCityObject.name = cityName[0];

      this.$emit('selected', { city: newCityObject, coordinates });
      this.hideModal();
    },
    hideModal() {
      this.clearLoading();
      this.$nextTick(() => this.$modal.hide('city-modal'));
    },
    clearLoading() {
      this.loadingStack = [];
    },
    async detectCity() {
      pushToDataLayer({ event: 'step2_location_change_auto' });
      this.setLoading(true);

      try {
        const { city, coordinates } = await geoDetectCity();
        this.detectError = false;
        this.setCity(city, coordinates);
      } catch (e) {
        this.detectError = true;
        sendErrorDataLayer('Ошибка определения города', e);
      } finally {
        this.setLoading(false);
      }
    },
    async updateLists() {
      this.setLoading(true);

      try {
        const { locations, regions } = await locationPopular.get();
        this.populars = locations;
        this.regions = regions;
      } catch (e) {
        sendErrorDataLayer('Ошибка получения популярных городов', e);
      } finally {
        this.setLoading(false);
      }
    },
    async updateRegionCities(city) {
      this.setLoading(true);

      try {
        const { cities } = await getCitiesOfRegion.post(city);
        this.regionCities = cities;
      } catch (e) {
        sendErrorDataLayer('Ошибка получения городов региона', e);
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
